function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".urgencia-emergencia_svg__b{fill:#161a47}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28 26H2a2 2 0 01-2-2V8a2 2 0 012-2h5V2a2 2 0 012-2h12a2 2 0 012 2v4h5a2 2 0 012 2v16a2 2 0 01-2 2zM9 2v4h12V2z",
  fill: "#c6d2ec",
  opacity: 0.54
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "urgencia-emergencia_svg__b",
  d: "M14 10h2v12h-2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "urgencia-emergencia_svg__b",
  d: "M21 15v2H9v-2z"
});

function SvgUrgenciaEmergencia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 26
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDMwIDI2Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojYzZkMmVjO29wYWNpdHk6MC41NDt9LmJ7ZmlsbDojMTYxYTQ3O308L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQ5IC01NDAxKSI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjMyIC0zMTEpIj48cGF0aCBjbGFzcz0iYSIgZD0iTS0yODYsMjZoLTI2YTIsMiwwLDAsMS0yLTJWOGEyLDIsMCwwLDEsMi0yaDVWMmEyLDIsMCwwLDEsMi0yaDEyYTIsMiwwLDAsMSwyLDJWNmg1YTIsMiwwLDAsMSwyLDJWMjRBMiwyLDAsMCwxLTI4NiwyNlpNLTMwNSwyVjZoMTJWMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzMSA1NzEyKSIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0LjgxNiA1NzQwLjIwNCkiPjxyZWN0IGNsYXNzPSJiIiB3aWR0aD0iMiIgaGVpZ2h0PSIxMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYuMTg0IC0xOC4yMDQpIi8+PHJlY3QgY2xhc3M9ImIiIHdpZHRoPSIyIiBoZWlnaHQ9IjEyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMy4xODQgLTEzLjIwNCkgcm90YXRlKDkwKSIvPjwvZz48L2c+PC9nPjwvc3ZnPg==";
export { SvgUrgenciaEmergencia as ReactComponent };